module.exports = __webpack_public_path__ + "408af04965e3fa3170109311cd77d67b.svg";